import { useRef, useEffect, useState } from "react";
import { SkyText, SkyLoader } from "@skypointcloud/skypoint-ui";
import { Styles } from "./SkypointLogoLoader.styles";
import { Styles as common } from "../../styles/common.styles";
import { ThemedLogo } from "../theme/ThemedLogo";
import { DEFAULT_PRODUCT, PRODUCT_WORDMARK, type ProductKey } from "../../../shared/products/keys";
import { resolveActiveProduct } from "../products/activeProduct";
import { readActiveChoice } from "../products/lastProduct";
import { peekInstanceId } from "../../utils/instanceId";

/**
 * The product whose wordmark the loader shows: the shell's own rule (resolveActiveProduct) in its
 * state before products resolve, which is when a loader is on screen. A product's own page decides
 * (`/performance/**`); a shared page (`/`, the sign-in callback, Users) keeps the product last
 * chosen on the instance in the URL or still selected. After a sign-out none is selected (logout
 * clears it), so a fresh sign-in shows hire until a product's own page opens. The loader renders before the router exists, so it reads the address
 * bar, and it only reads: drawing a loader never stores an instance.
 */
function loaderProduct(): ProductKey {
  const instanceId = peekInstanceId();
  return resolveActiveProduct({
    pathname: window.location.pathname,
    stored: instanceId ? readActiveChoice(instanceId) : null,
    ready: false,
    enabled: [],
    held: [],
  }).product;
}

let hasShownLoader = false;

const SkypointLogoLoader = () => {
  const skipAnimation = useRef(hasShownLoader);

  useEffect(() => {
    hasShownLoader = true;
  }, []);

  const noAnimation = { animation: "none", opacity: 1, transform: "none" };
  const [product] = useState(loaderProduct);
  const wordmark = PRODUCT_WORDMARK[product];

  return (
    <>
      {!skipAnimation.current && (
        <style>
          {`
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(10px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>
      )}
      <div style={Styles.wrapper}>
        <div style={Styles.logoContainer}>
          <ThemedLogo
            src={wordmark.dark}
            darkSrc={wordmark.light}
            // Hire keeps the alt text it has always had (zero change for hire-only tenants).
            alt={product === DEFAULT_PRODUCT ? "skyHire Logo" : wordmark.alt}
            style={{
              ...Styles.logoImage,
              ...(product === DEFAULT_PRODUCT ? {} : Styles.wideLogoImage),
              ...(skipAnimation.current ? noAnimation : {}),
            }}
          />
        </div>

        <div
          style={
            skipAnimation.current
              ? { ...Styles.loaderWrapper, ...noAnimation }
              : Styles.loaderWrapper
          }
        >
          <SkyLoader className="flex items-center justify-center" />
        </div>

        <div
          style={
            skipAnimation.current
              ? { ...Styles.poweredByWrapper, ...noAnimation }
              : Styles.poweredByWrapper
          }
        >
          <SkyText style={common.boldText}>Powered by</SkyText>
          <ThemedLogo
            src="/dist/img/skyPoint-logo-text-black.svg"
            darkSrc="/dist/img/skyPoint-logo-text-white.svg"
            style={Styles.poweredByImage}
            alt="Skypoint"
          />
        </div>
      </div>
    </>
  );
};

export default SkypointLogoLoader;
